//test
export const getType = state => {
    return state.type
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js